"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../assets/css/components/hover-card.css");

var _PayUIcons = _interopRequireDefault(require("../PayUIcons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var OnHoverCard = function OnHoverCard(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Top Heading" : _ref$heading,
      _ref$subHeading = _ref.subHeading,
      subHeading = _ref$subHeading === void 0 ? "Sub Heading" : _ref$subHeading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    console.log("On Click callback");
  } : _ref$onClick,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "transactions" : _ref$icon,
      rest = _objectWithoutProperties(_ref, ["heading", "subHeading", "onClick", "icon"]);

  return _react["default"].createElement("div", {
    className: "col-md-3"
  }, _react["default"].createElement("div", {
    role: "button",
    onKeyPress: function onKeyPress() {},
    tabIndex: 0,
    onClick: onClick,
    className: "paymentOPtionblock"
  }, _react["default"].createElement("div", {
    className: "green-block"
  }, _react["default"].createElement(_PayUIcons["default"], {
    type: icon,
    size: "50px",
    color: "white"
  })), _react["default"].createElement("h4", {
    className: "card-title"
  }, heading || "", _react["default"].createElement("br", null), _react["default"].createElement("span", null, subHeading || ""))));
};

OnHoverCard.propTypes = {
  onClick: _propTypes["default"].func,
  heading: _propTypes["default"].string,
  subHeading: _propTypes["default"].string,
  icon: _propTypes["default"].string
};
var _default = OnHoverCard;
exports["default"] = _default;